interface IMediaType {
  mimeType: string;
  extensions: string[];
}

function getMediaTypesExtensions(mediaTypes: IMediaType[]): string[] {
  return mediaTypes.reduce(
    (result, type) => result.concat(type.extensions),
    [],
  );
}

function getMediaTypesSpecifiers(mediaTypes: IMediaType[]): string[] {
  return mediaTypes.reduce(
    (result, type) =>
      result.concat(`${type.mimeType}, ${type.extensions.join(', ')}`),
    [],
  );
}

const IMAGE_WEBP = { mimeType: 'image/webp', extensions: ['.webp'] };
const IMAGE_BMP = { mimeType: 'image/bmp', extensions: ['.bmp'] };
const IMAGE_GIF = { mimeType: 'image/gif', extensions: ['.gif'] };
const IMAGE_JPEG = { mimeType: 'image/jpeg', extensions: ['.jpeg'] };
const IMAGE_JPG = { mimeType: 'image/jpg', extensions: ['.jpg'] };
const IMAGE_PNG = { mimeType: 'image/png', extensions: ['.png'] };
const IMAGE_TIFF = { mimeType: 'image/tiff', extensions: ['.tiff', '.tif'] };

const SUPPORTED_IMAGES: IMediaType[] = [
  IMAGE_WEBP,
  IMAGE_BMP,
  IMAGE_GIF,
  IMAGE_JPEG,
  IMAGE_JPG,
  IMAGE_PNG,
  IMAGE_TIFF,
];

const SUPPORTED_LOGO_IMAGES: IMediaType[] = [
  IMAGE_JPG,
  IMAGE_PNG,
  IMAGE_GIF,
  // TODO: uncomment when fixed magisto error https://jira.wixpress.com/browse/VMAF-234
  // IMAGE_TIFF,
  IMAGE_BMP,
];

const VIDEO_3GP = { mimeType: 'video/3gp', extensions: ['.3gp'] };
const VIDEO_AVI = { mimeType: 'video/avi', extensions: ['.avi'] };
// const VIDEO_M2TS = { mimeType: 'video/m2ts', extensions: ['.m2ts'] };
const VIDEO_MOV = { mimeType: 'video/mov', extensions: ['.mov'] };
const VIDEO_MP4 = { mimeType: 'video/mp4', extensions: ['.mp4'] };
const VIDEO_MPG = { mimeType: 'video/mpg', extensions: ['.mpg'] };
const VIDEO_MTS = { mimeType: 'video/mts', extensions: ['.mts'] };

const SUPPORTED_VIDEOS: IMediaType[] = [
  VIDEO_3GP,
  VIDEO_AVI,
  // TODO: uncomment when fixed magisto error  https://jira.wixpress.com/browse/VMAF-235
  // VIDEO_M2TS,
  VIDEO_MOV,
  VIDEO_MP4,
  VIDEO_MPG,
  VIDEO_MTS,
];

const SUPPORTED_IMAGES_EXTENSIONS = getMediaTypesExtensions(SUPPORTED_IMAGES);
const SUPPORTED_VIDEOS_EXTENSIONS = getMediaTypesExtensions(SUPPORTED_VIDEOS);

const SUPPORTED_IMAGES_SPECIFIERS = getMediaTypesSpecifiers(SUPPORTED_IMAGES);
const SUPPORTED_VIDEOS_SPECIFIERS = getMediaTypesSpecifiers(SUPPORTED_VIDEOS);

const SUPPORTED_LOGO_IMAGES_SPECIFIERS = getMediaTypesSpecifiers(
  SUPPORTED_LOGO_IMAGES,
);

const SUPPORTED_MEDIA_EXTENSIONS = [
  ...SUPPORTED_IMAGES_EXTENSIONS,
  ...SUPPORTED_VIDEOS_EXTENSIONS,
];

const SUPPORTED_MEDIA_SPECIFIERS = [
  ...SUPPORTED_IMAGES_SPECIFIERS,
  ...SUPPORTED_VIDEOS_SPECIFIERS,
];

export {
  SUPPORTED_IMAGES_EXTENSIONS,
  SUPPORTED_IMAGES_SPECIFIERS,
  SUPPORTED_VIDEOS_EXTENSIONS,
  SUPPORTED_VIDEOS_SPECIFIERS,
  SUPPORTED_LOGO_IMAGES_SPECIFIERS,
  SUPPORTED_MEDIA_EXTENSIONS,
  SUPPORTED_MEDIA_SPECIFIERS,
};
